import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowLeft, LogOut, LayoutDashboard, Inbox, Warehouse, BookOpen, Car, Handshake } from "lucide-react";
import { BlogGestione } from "@/components/BlogGestione";
import { PartnerGestione } from "@/components/PartnerGestione";
import { useSeo } from "@/lib/seo";
import { Logo } from "@/components/Logo";
import { KnowledgeBase } from "@/components/KnowledgeBase";
import { VeicoliGestione } from "@/components/VeicoliGestione";
import { LeadsRendiconto } from "@/components/LeadsRendiconto";
import { UsatoGestione, fa } from "@/components/UsatoGestione";
import { Tendina } from "@/components/Tendina";
import { AdminGate } from "@/components/AdminGate";
import { logout } from "@/lib/auth";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AssistenteContenuti() {
  return (
    <AdminGate>
      <Pannello />
    </AdminGate>
  );
}

function Pannello() {
  useSeo({ title: "Pannello gestione | XMOVE (interno)", description: "Strumento interno.", path: "/assistente-contenuti/" });
  const [stato, setStato] = useState(null);
  useEffect(() => {
    axios.get(`${API}/admin/usato/stato`).then((r) => setStato(r.data)).catch(() => {});
  }, []);
  const badgeUsato = stato?.fermo ? { tipo: "alert", testo: "Import fermo" } : stato?.ultimo_import ? { testo: `ultimo import ${fa(stato.ultimo_import)}` } : null;

  return (
    <div className="min-h-screen bg-xmove-cream" data-testid="content-assistant-page">
      <header className="border-b border-xmove-ink/8 bg-white">
        <div className="mx-auto flex h-16 max-w-5xl items-center justify-between px-5">
          <Logo />
          <div className="flex items-center gap-4">
            <Link to="/" data-testid="assistant-back-link" className="flex items-center gap-1.5 text-sm font-semibold text-xmove-muted hover:text-xmove-orange">
              <ArrowLeft size={15} /> Torna al sito
            </Link>
            <button type="button" onClick={logout} data-testid="admin-logout-btn" className="flex items-center gap-1.5 rounded-lg border border-xmove-ink/15 px-3 py-1.5 text-xs font-bold text-xmove-muted transition-colors hover:border-xmove-night hover:text-xmove-night">
              <LogOut size={13} /> Esci
            </button>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-5xl px-5 py-10">
        <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-xmove-orange">
          <LayoutDashboard size={14} /> Area riservata · Strumento interno
        </p>
        <h1 className="mt-2 font-display text-3xl font-bold text-xmove-ink sm:text-4xl">Pannello gestione XMOVE</h1>
        <p className="mt-3 max-w-2xl text-sm leading-relaxed text-xmove-muted">
          Apri la sezione che ti serve: richieste ricevute, stock usato, assistente AI e catalogo veicoli. Le tendine restano come le lasci.
        </p>

        <div className="mt-8">
          <Tendina id="leads" titolo="Richieste ricevute" descrizione="Chi ha compilato i form: data, auto richiesta, contatti, export CSV" icona={Inbox}>
            <LeadsRendiconto />
          </Tendina>
          <Tendina id="usato" titolo="Auto usate" descrizione="Stock importato dal portale: prezzi, esempi di quotazione, visibilità, chiave API" icona={Warehouse} badge={badgeUsato}>
            <UsatoGestione />
          </Tendina>
          <Tendina id="blog" titolo="Blog / Guide" descrizione="Articoli: bozza con l'AI, correzione, pubblicazione" icona={BookOpen}>
            <BlogGestione />
          </Tendina>
          <Tendina id="partner" titolo="Partner YouTire" descrizione="Officine registrate e richieste segnalate dalla rete" icona={Handshake}>
            <PartnerGestione />
          </Tendina>
          <Tendina id="knowledge" titolo="Assistente AI" descrizione="File e documenti da cui l'assistente in chat impara" icona={BookOpen}>
            <KnowledgeBase />
          </Tendina>
          <Tendina id="veicoli" titolo="Offerte e veicoli" descrizione="Noleggio lungo termine: canoni, varianti, testi SEO, foto" icona={Car}>
            <VeicoliGestione />
          </Tendina>
        </div>
      </main>
    </div>
  );
}
